// src/ConsumerApp/api/addresses/deliveryAddress.hooks.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DeliveryAddressService } from './deliveryAddress.service';

export const useGetDeliveryAddresses = (customerId) => {
  return useQuery({
    queryKey: ['deliveryAddresses', customerId],
    queryFn: () => DeliveryAddressService.getDeliveryAddresses(customerId),
    enabled: Boolean(customerId),
    staleTime: 1000 * 60 * 5,
  });
};

export const useSelectDeliveryAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ customer_id, delivery_address_id }) => {
      // Endpoint to persist the user's active/default site address
      return DeliveryAddressService.updateDeliveryAddress({
        addressId: delivery_address_id,
        payload: { customer_id, is_default: true },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['defaultDeliveryAddress', variables.customer_id] });
      queryClient.invalidateQueries({ queryKey: ['deliveryAddresses', variables.customer_id] });
      queryClient.invalidateQueries({ queryKey: ['bucketDetails'] });
    },
  });
};

export const useDeleteDeliveryAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (addressId) => DeliveryAddressService.deleteDeliveryAddress(addressId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deliveryAddresses'] });
      queryClient.invalidateQueries({ queryKey: ['defaultDeliveryAddress'] });
    },
  });
};